module.exports = __webpack_public_path__ + "static/scale-model-of-salem-oregon-a5b0c148fcdba5b25c1b3b39a2181e65.png";